import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MultiSelectChip from "./elements/MultiSelectChip";
import StyledSelect from "./elements/StyledSelect";
import { Grid } from "@mui/material";

export default function CountryTable({
  rows,
  handleDeleteCountryVersions,
  assignVersion,
  selectedModelVersions,
}) {
  return (
    <Table sx={{ minWidth: 650 }} aria-label="country table">
      <TableHead>
        <TableRow>
          <TableCell align="left">Country</TableCell>
          <TableCell align="left">Module Version</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow
            key={row.name}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell component="th" scope="row" align="left">
              {row.country}
            </TableCell>
            <TableCell align="left">
              <Grid
                container
                spacing={3}
                justifyContent={"left"}
                alignItems={"flex-end"}
              >
                {row?.versions?.length !== selectedModelVersions?.length && (
                  <>
                    <Grid item xs={12} md={3}>
                      <StyledSelect
                        defaultVal={"Module Version"}
                        options={selectedModelVersions}
                        control={"init"}
                        setControl={(e) => {
                          assignVersion({ country: row.country, version: e });
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={9}>
                  <MultiSelectChip
                    models={row.versions}
                    handleDelete={(e) => {
                      handleDeleteCountryVersions({
                        country: row.country,
                        version: e,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
